import localee32c8782 from '../../locale/no.json'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"nb_NO","numberFormats":{"nb_NO":{"currency":{"style":"currency","currency":"NOK","currencyDisplay":"symbol"}}}},
  vueI18nLoader: false,
  locales: [{"code":"nb_NO","file":"no.json","iso":"no","defaultCurrency":"NOK"}],
  defaultLocale: "nb_NO",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_and_default",
  lazy: true,
  langDir: "/var/www/dfs_wc/app/locale/",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  seo: true,
  baseUrl: "https://www.dfsnettbutikk.no",
  vuex: {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  country: "NO",
  normalizedLocales: [{"code":"nb_NO","file":"no.json","iso":"no","defaultCurrency":"NOK"}],
  localeCodes: ["nb_NO"],
}

export const localeMessages = {
  'no.json': () => Promise.resolve(localee32c8782),
}
